module.exports = __webpack_public_path__ + "img/zhuozi_footer.fd562156.png";